<template>
    <div class="index-page" dark-class="index-page-dark">
        <!-- 移动端菜单 -->
        <nav id="menu-mobile">
            <ul>
                <li v-for="(item, idx) in menus" :key="idx">
                    <a :href="item.href" child>{{ item.name }}</a>
                    <ul v-if="item.child" v-html="getMobileMenuChild(item.child)"></ul>
                </li>
            </ul>
        </nav>

        <!-- 左侧栏 PC 菜单 -->
        <div class="sidebar">
            <div class="info-box">
                <img class="icon" v-if="setting_info.icon" :src="setting_info.icon.url" />
            </div>
            <div class="main-menu-pc">
                <div class="menu-item" v-for="(menu, idx) in menus" :key="idx" :class="{ 'menu-item-activity': d_menu_root === menu.root }">
                    <a class="menu-item-box" :href="menu.href">
                        <img class="icon" :src="'static/icon/menu_icon/' + menu.icon" />
                        <p class="name">{{ menu.name }}</p>
                    </a>
                    <div class="menu-child-base" v-if="menu.child">
                        <comp-menu-child :child="menu.child" @hide="hideMenuChild"></comp-menu-child>
                    </div>
                </div>
            </div>
            <div class="main-menu-pc">
                <div class="menu-item" v-for="(menu, idx) in submenus" :key="idx" :class="{ 'menu-item-activity': d_menu_root === menu.root }">
                    <a class="menu-item-box" :href="menu.href" :title="menu.name">
                        <img class="icon" :src="'static/icon/menu_icon/' + menu.icon" />
                    </a>
                    <div class="menu-child-base" v-if="menu.child">
                        <comp-menu-child :child="menu.child" @hide="hideMenuChild"></comp-menu-child>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="secondary-page">
            <div class="smart-assistant">
                <div class="icon-box">
                    <elem-icon name="smart"></elem-icon>
                </div>
                <div class="speak-content">
                    您好，我是您的智能助理 Jimmy !
                </div>
            </div>
            <div class="quick-entry-box">
                <div class="menu-box">
                    <div class="item-box" v-for="(item, idx) in 5" :key="idx">
                        <div class="icon-box">
                            <img class="icon" src="static/icon/menu_icon/data.svg" alt="">
                        </div>
                        <p class="name">语言包</p>
                    </div>
                </div>
            </div>
        </div> -->

        <div class="column-box">
            <div class="head-box">
                <div class="page-name">
                    <div class="menu-icon" @click="menu.open()">
                        <elem-icon name="menu"></elem-icon>
                    </div>
                    <div class="icon">
                        <elem-icon src="static/icon/menu_icon/" :key="page_icon" :name="page_icon"></elem-icon>
                    </div>
                    <p class="name">{{ page_title }}</p>
                </div>
                <div class="operating-box">
                    <div class="search-box">
                        <div class="search-base" :class="{ 'search-activity': display_search }">
                            <div class="search">
                                <div class="icon-box">
                                    <elem-icon name="search_white"></elem-icon>
                                </div>
                                <div class="search-input">
                                    <input placeholder="搜索功能模块" @blur="onSearchInputBlur" @focus="onSearchInputFocus" @input="onSearchInput" @keyup.enter="onSearchSubmit" />
                                </div>
                            </div>
                            <div class="search-result" v-show="display_search && search_result && search_result.length > 0">
                                <div class="result-item" v-for="(item, idx) in search_result" :key="idx" @mousedown="onJumpHref(item.href)">
                                    <p class="name">{{ item.title }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="btn-box" @click="jump('/message')">
                        <elem-icon class="icon" name="notice_white" hover="#2faaf7" width="20px" height="20px"></elem-icon>
                    </div>
                    <div class="btn-box">
                        <elem-icon class="icon" name="setting_white" hover="#2faaf7" width="20px" height="20px"></elem-icon>
                        <comp-menu :value="settingMenu" @select="onSelectSettingMenu"></comp-menu>
                    </div>
                    <div class="user-box">
                        <div class="avatar-box">
                            <img class="avatar" v-if="userinfo?.avatar" :src="userinfo.avatar.url" />
                            <elem-icon class="icon" v-else name="user"></elem-icon>
                            <div class="status"></div>
                        </div>
                        <div class="btn-icon">
                            <elem-icon name="arrow_bottom_white"></elem-icon>
                        </div>
                        <comp-menu :value="userMenu" @select="onSelectUserMenu"></comp-menu>
                    </div>
                </div>
            </div>

            <!-- 页面内容 -->
            <div class="content-box" dark-class="content-dark" id="Content" :class="{ 'online-activity': isDisplayOnlineServicePage }">
                <div class="content-scroll" @scroll="onScroll">
                    <router-view v-slot="{ Component }">
                        <keep-alive>
                            <component :is="Component" />
                        </keep-alive>
                    </router-view>
                </div>
            </div>
        </div>

        <page-about></page-about>
    </div>
</template>

<script lang="ts">
import Mmenu from "mmenu-js"
import "mmenu-js/dist/mmenu.css"

import Utils from "@/module/utils/utils"
import Component, { ComponentMethods } from "@/module/component/component"
import Cache from "@/module/cache/cache"
import Href from "@/module/config/href"
import Theme from "@/module/theme/theme"
import Message from "@/module/interactive/message"

import elemIcon from "@/components/elem-icon.vue"
import elemOptions from "@/components/elem-options.vue"
import compMenu from "@/components/comp-menu.vue"
import pageAbout from "@/components/page-about.vue"
import compMenuChild from "@/components/comp-menu-child.vue"

import Version from "@/module/version/version"

class Framework {
    private static index: IndexView

    public static setTitle(title: string, icon?: string): void {
        this.index.page_title = title
        this.index.page_icon = icon || "data"
    }

    public static setIndex(index: IndexView) {
        this.index = index
    }
}

class IndexView extends ComponentMethods implements ComponentEntity {
    public page_title: string = "首页"

    public page_icon: string = "data"

    public d_menu_root: string = null

    public menus: MenuObj[] = null

    public submenus = null

    public userMenu = [
        {
            title: "账号管理",
            sub: [
                {
                    id: "edit_password",
                    icon: "password",
                    name: "修改密码",
                },
                {
                    id: "sign_out",
                    icon: "sign_out",
                    name: "退出登录",
                },
            ],
        },
    ]

    public settingMenu = [
        {
            title: "主题",
            prompt: "自动模式下，将根据系统主题自动切换浅色模式或深色模式。",
            sub: [
                {
                    id: "auto_theme",
                    icon: "auto",
                    name: "自动模式",
                },
                {
                    id: "light_theme",
                    icon: "light",
                    name: "浅色模式",
                },
                {
                    id: "dark_theme",
                    icon: "dark",
                    name: "深色模式",
                },
            ],
        },
        {
            title: "系统",
            sub: [
                {
                    id: "update",
                    icon: "update",
                    name: "检查更新",
                },
                {
                    id: "version",
                    icon: "about",
                    name: "版本",
                },
            ],
        },
    ]

    data() {
        return {
            online_service_user_id_activity: null,

            // 是否显示在线服务页面
            isDisplayOnlineServicePage: false,

            // 在线服务菜单
            online_service_menu: "new",

            chats: [
                {
                    isCurrent: false,
                    type: "user",
                    name: "晟浩科技",
                    date: "2019-08-22 10:00",
                    content: "测试内容",
                },
                {
                    isCurrent: true,
                    type: "admin",
                    name: "晟浩科技",
                    date: "2019-08-22 10:00",
                    content: "测试内容",
                },
            ],

            search_result: [],

            display_search: false,

            setting_info: Cache.get("setting_info"),

            userinfo: Cache.get("userinfo"),
        }
    }

    components = {
        elemIcon,
        compMenu,
        elemOptions,
        pageAbout,
        compMenuChild,
    }

    watch = {
        $route: async function (to) {
            this.processRoute(to)
        },
    }

    created() {
        Framework.setIndex(this)

        Href.get().then(res => {
            this.menus = Utils.copy(res.menus)
            this.submenus = Utils.copy(res.submenus)

            setTimeout(() => {
                this._setMenuChildBoxStyle()

                this.menu = new Mmenu("#menu-mobile", {
                    theme: "dark",
                })

                // 为所有菜单链接绑定点击事件，点击后关闭菜单
                const menuLinks = document.querySelectorAll("#menu-mobile a[child]")
                menuLinks.forEach(link => {
                    link.addEventListener("click", () => {
                        this.menu.close()
                    })
                })
            })
        })

        Cache.onGet("userinfo", v => {
            this.userinfo = v
        })
    }

    mounted() {
        this.processRoute()
    }

    beforeDestroy() {
        this.menu?.destroy()
    }

    /**
     * 监听窗口大小变化事件
     */
    onResize() {
        this._setMenuChildBoxStyle()
    }

    /**
     * 监听内容组件滚动事件
     */
    onScroll(evt: obj): void {
        const e: HTMLDivElement = evt.target
        var wScrollY = e.scrollTop // 当前滚动条位置
        var wInnerH = e.clientHeight // 设备窗口的高度（不会变）
        var bScrollH = e.scrollHeight // 滚动条总高度
        if (wScrollY + wInnerH >= bScrollH - 20) {
            if (this.isOnBottom) return
            this.isOnBottom = true
            const page = this.$route.matched[0].instances.default
            // 触发触底事件
            page?.onReachBottom && page.onReachBottom()
        } else {
            this.isOnBottom = false
        }
    }

    processRoute(route?: obj) {
        // 关闭所有消息框
        Message.closeAll()

        Utils.wait(() => {
            if (typeof route === "undefined") {
                route = this.$route
            }

            if (route.matched.length <= 0) {
                return
            }

            const page = route.matched[0].instances.default
            // 设置页面标题
            this.page_title = (typeof page.title === "function" ? page.title() : page.title) || "首页"
            // 设置页面图标
            this.page_icon = page.icon || "data"
            // 写入框架方法
            if (typeof page.framework === "undefined") {
                page.framework = Framework
            }
            // 触发 onLoad 事件
            page.onLoad && page.onLoad(page.getParams())
        })
    }

    onSelectSettingMenu(evt: CompEvent<any>) {
        switch (evt.value) {
            case "auto_theme":
                Theme.changeTheme("auto")
                break
            case "dark_theme":
                Theme.changeTheme("dark")
                break
            case "light_theme":
                Theme.changeTheme("light")
                break
            case "update":
                Version.check()
                break
            case "version":
                Version.get().then(res => {
                    Message.info(`管理端版本：${res.admin}，框架版本：${res.framework}`)
                })
        }
    }

    /** 设置子菜单样式 */
    private _setMenuChildBoxStyle() {
        Utils.getElementAll<HTMLDivElement>(".menu-child-base", e => {
            const p = e.getBoundingClientRect()

            if (p.height + p.y + 100 > window.innerHeight) {
                if (!e.classList.contains("menu-child-box-bottom")) {
                    e.classList.add("menu-child-box-bottom")
                }
            } else {
                if (e.classList.contains("menu-child-box-bottom")) {
                    e.classList.remove("menu-child-box-bottom")
                }
            }
        })
    }

    /**
     * 获取移动端子菜单模板
     * @param child 子菜单
     */
    public getMobileMenuChild(child: MenuObj[], isBase?: boolean): string {
        var childs = ""

        Utils.each(child, v => {
            childs += `
                <li>
                    <a ${v.href ? 'href="' + v.href + '"' : ""} child>${v.name}</a>
                    ${v.child ? this.getMobileMenuChild(v.child, true) : ""}
                </li>
            `
        })

        return isBase ? `<ul>${childs}</ul>` : childs
    }

    public hideMenuChild() {
        const dom = document.querySelectorAll<HTMLDivElement>(".menu-child-box")

        if (dom.length > 0) {
            Utils.eachNode(dom, v => {
                v.hidden = true
                // 使用延时将子菜单可显示状态
                setTimeout(() => {
                    v.hidden = false
                }, 100)
            })
        }
    }

    /**
     * 监听用户菜单
     * @param evt 值
     */
    onSelectUserMenu(evt: obj): void {
        const value = evt.value

        switch (value) {
            case "sign_out":
                Message.info("确认退出当前账号？", true)
                    .onConfirm(() => {
                        // 移除所有缓存
                        Cache.clear()
                        // 刷新页面
                        window.location.reload()
                    })
                    .build()
                break
            case "edit_password":
                this.jump("/table?name=AdminAccount")
        }
    }

    /**
     * 监听搜索框聚焦事件
     */
    onSearchInputFocus() {
        this.display_search = true
    }

    /**
     * 监听搜索框失焦事件
     */
    onSearchInputBlur() {
        setTimeout(() => {
            this.display_search = false
        }, 200)
    }

    /**
     * 监听搜索框变化事件
     * @param evt event
     */
    async onSearchInput(evt: InputEvent) {
        const node: HTMLInputElement = Utils.getNode(evt)

        const val = node.value
        const pages: obj[] = (await Href.get()).pages

        if (!val) {
            this.search_result = []
            return
        }

        this.search_result = pages.filter(v => v.title.includes(val)).map(v => {
            var href: string

            switch (v.type) {
                case "config":
                    href = `/admin/#/form?type=config&name=${v.name}`
                    break
                default:
                    href = `/admin/#/table?name=${v.name}`
            }

            return {
                title: v.title,
                href: href
            }
        })
    }

    /**
     * 监听搜索框提交事件
     */
    onSearchSubmit() {
        if (!this.search_result || this.search_result.length <= 0) {
            Message.info("暂无搜索结果")
        }
    }

    /**
     * 跳转链接
     * @param href 链接
     */
    onJumpHref(href: string) {
        window.location.href = href
    }
}

interface MenuObj {
    icon: string
    href?: string
    root?: string
    component?: string
    name?: string
    child?: MenuObj[]
}

export default Component.build(new IndexView())
</script>

<style lang="less">
@import (reference) "@/style/utils.less";
@import (reference) "@/style/color.less";

// @import "mmenu.css";

// .mm-page {
//     position: absolute;
//     min-height: 100%;
//     width: 100%;
// }

.index-page {
    overflow: hidden;
    background: linear-gradient(to bottom right, #117bbd, #00293e 90%);

    .flex;
    .fixed(0, 0, 0, 0);

    // #menu-mobile {
    //     display: none;

    //     @media (max-width: 700px) {
    //         display: inline-block;
    //     }
    // }

    .sidebar {
        margin: 20px 0 20px 20px;
        width: 100px;
        z-index: 50;
        background: rgba(16, 42, 67, 0.5);
        backdrop-filter: blur(24px);
        -webkit-backdrop-filter: blur(24px);
        border: 1px solid rgba(255, 255, 255, 0.08);

        .border-box;
        .flex-shrink;
        .shadow(0 15px 40px rgba(0, 0, 0, 0.25));
        .radius(30px);
        .flex;
        .flex-column;
        .flex-center-items;

        @media (max-width: 700px) {
            display: none;
        }

        > .info-box {
            width: 100%;
            height: 110px;

            .flex;
            .flex-center-all;

            .icon {
                width: 45px;
                height: 45px;
            }
        }

        .main-menu-pc {
            margin: clamp(10px, 3vh, 40px) 0;
            width: 100%;
            padding: 0 16px;
            box-sizing: border-box;

            .flex();
            .flex-column();

            .menu-item {
                position: relative;
                width: 100%;
                height: 70px;
                margin: 6px 0;
                border-radius: 16px;
                transition: all 0.3s cubic-bezier(0.2, 0.8, 0.2, 1);
                cursor: pointer;

                &::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    border-radius: 16px;
                    background: rgba(255, 255, 255, 0.08);
                    opacity: 0;
                    transition: opacity 0.3s ease;
                    z-index: 0;
                }

                .menu-item-box {
                    position: relative;
                    height: 100%;
                    width: 100%;
                    z-index: 1;

                    .flex();
                    .flex-center-all();

                    .icon {
                        filter: grayscale(100%) opacity(0.5);
                        width: 24px;
                        height: 24px;

                        .transition(all 0.3s cubic-bezier(0.2, 0.8, 0.2, 1));
                    }

                    .name {
                        position: absolute;
                        left: 50%;
                        bottom: -10px;
                        transform: translateX(-50%) scale(0.8);
                        background: rgba(30, 35, 41, 0.95);
                        color: #ffffff;
                        font-size: 13px;
                        font-weight: 500;
                        letter-spacing: 1px;
                        padding: 6px 14px;
                        border-radius: 8px;
                        white-space: nowrap;
                        pointer-events: none;
                        opacity: 0;
                        z-index: 200;
                        border: 1px solid rgba(255, 255, 255, 0.1);
                        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.25);

                        .transition(all 0.3s cubic-bezier(0.2, 0.8, 0.2, 1));
                    }
                }

                .menu-child-base {
                    visibility: hidden;
                    opacity: 0;
                    transform: translateX(15px);
                    z-index: 100;

                    .absolute(0, initial, initial, 100%);
                    .transition(all 0.3s cubic-bezier(0.2, 0.8, 0.2, 1));

                    &::after {
                        content: "";
                        width: 0;
                        height: 0;
                        border-top: 8px solid transparent;
                        border-right: 12px solid rgba(255, 255, 255, 0.96);
                        border-bottom: 8px solid transparent;

                        .absolute(20px, initial, initial, 16px);
                    }

                    .menu-child-box {
                        position: relative;
                        background: rgba(250, 252, 255, 0.96);
                        backdrop-filter: blur(24px);
                        margin-left: 28px;
                        min-width: 220px;
                        padding: 16px;
                        box-sizing: border-box;

                        .shadow(0 20px 50px rgba(0, 0, 0, 0.15));
                        .radius(24px);
                        border: 1px solid rgba(255, 255, 255, 0.8);

                        .menu-child-item {
                            position: relative;
                            height: 54px;
                            margin-bottom: 8px;
                            border-radius: 14px;
                            
                            &:last-child {
                                margin-bottom: 0;
                            }

                            > .menu-child-base {
                                &::after {
                                    top: 19px;
                                }

                                &.menu-child-box-bottom {
                                    &::after {
                                        top: auto;
                                        bottom: 19px;
                                    }
                                }
                            }

                            &:hover {
                                > .menu-child-base {
                                    visibility: initial;
                                    opacity: 1;
                                    transform: translateX(0);
                                }

                                > .menu-child-item-box {
                                    background: #fff;
                                    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
                                    transform: translateX(6px);
                                    
                                    .menu-child-icon {
                                        filter: grayscale(0);
                                        transform: scale(1.1);
                                    }
                                    .menu-child-name {
                                        color: #0088ff;
                                        font-weight: 600;
                                    }
                                    .arrow-icon {
                                        filter: grayscale(0);
                                    }
                                }
                            }

                            .menu-child-item-box {
                                position: relative;
                                height: 100%;
                                padding: 0 20px;
                                border-radius: 14px;
                                text-decoration: none;
                                outline: none;
                                transition: all 0.3s cubic-bezier(0.2, 0.8, 0.2, 1);

                                .flex();
                                .flex-center-items();

                                .menu-child-icon {
                                    filter: grayscale(1) opacity(0.6);
                                    width: 18px;
                                    height: 18px;

                                    .transition(all 0.3s ease);
                                    .flex-shrink();
                                }

                                .menu-child-name {
                                    margin: 0 16px;
                                    color: #555;
                                    font-size: 15px;
                                    font-weight: 500;
                                    letter-spacing: 1px;
                                    white-space: nowrap;
                                    overflow: hidden;
                                    text-overflow: ellipsis;

                                    .transition(all 0.3s ease);
                                    .flex-grow();
                                }

                                .arrow-icon {
                                    filter: grayscale(1) opacity(0.3);
                                    width: 14px;
                                    height: 14px;

                                    .transition(all 0.3s ease);
                                    .flex-shrink();
                                }
                            }
                        }
                    }
                }

                .menu-child-box-bottom {
                    .absolute(initial, initial, 0, 100%);

                    &::after {
                        .absolute(initial, initial, 20px, 16px);
                    }
                }

                &:hover {
                    &::before {
                        opacity: 1;
                    }
                    transform: translateY(-2px);

                    .menu-item-box {
                        .icon {
                            filter: grayscale(0) opacity(1);
                            transform: scale(1.1);
                        }

                        .name {
                            opacity: 1;
                            transform: translateX(-50%) scale(1);
                            bottom: -36px;
                        }
                    }

                    > .menu-child-base {
                        visibility: initial;
                        opacity: 1;
                        transform: translateX(0);
                    }
                }
            }

            .menu-item-activity {
                background: linear-gradient(135deg, #0088ff 0%, #0055ff 100%);
                box-shadow: 0 8px 24px rgba(0, 136, 255, 0.4);

                &::after {
                    display: none;
                }

                &:hover {
                    &::before {
                        opacity: 0;
                    }
                    transform: translateY(-2px);
                }

                .menu-item-box {
                    .icon {
                        filter: grayscale(0) opacity(1);
                        transform: scale(1.1);
                    }
                    
                    .name {
                        opacity: 1;
                        transform: translateX(-50%) scale(1);
                        bottom: -36px;
                        background: linear-gradient(135deg, #0088ff 0%, #0055ff 100%);
                        border: none;
                        box-shadow: 0 4px 15px rgba(0, 136, 255, 0.4);
                    }
                }
            }
        }
    }

    > .secondary-page {
        width: 600px;
        height: 100%;

        .smart-assistant {
            width: 100%;
            height: 50%;
            background: #000;
            padding: 20%;

            .border-box;

            .icon-box {
                width: 30px;
                height: 30px;
            }

            .speak-content {
                margin: 20px 0;
                color: #fff;
                font-size: 18px;
            }
        }

        .quick-entry-box {
            width: 100%;
            height: 50%;
            background: #fff;
            padding: 20%;
            overflow: auto;

            .border-box;

            .menu-box {
                .flex;
                .flex-wrap;

                > .item-box {
                    margin: 10px;
                    width: 50px;
                    height: 80px;

                    .icon-box {
                        width: 50px;
                        height: 50px;
                        padding: 10px;
                        background: #fff;

                        .border;
                        .border-box;
                        .radius(10px);
                        .shadow(0 0 10px rgba(0, 0, 0, 0.05));

                        .icon {
                            width: 100%;
                            height: 100%;
                        }
                    }

                    .name {
                        line-height: 30px;
                        font-size: 14px;
                        text-align: center;
                        color: #333;
                    }
                }
            }
        }

        .quick-view-box {
            width: 100%;
            height: 50%;
            background: #fff;
        }
    }

    > .column-box {
        overflow: hidden;

        .flex;
        .flex-column;
        .flex-grow;

        > .head-box {
            position: relative;
            min-height: 80px;
            padding: 10px 20px 0 20px;
            margin: 0 40px;
            z-index: 50;

            .flex-shrink;
            .border-box;
            .flex;
            .flex-center-items;
            .flex-content(space-between);

            @media (max-width: 700px) {
                min-height: 50px;
                padding: 10px 0 0 0;
            }

            .page-name {
                .flex;
                .flex-center-items;

                .icon {
                    width: 23px;
                    height: 23px;

                    @media (max-width: 700px) {
                        display: none;
                    }
                }

                .menu-icon {
                    width: 23px;
                    height: 23px;
                    display: none;

                    @media (max-width: 700px) {
                        display: block;
                    }
                }

                .name {
                    margin-left: 20px;
                    font-size: 20px;
                    color: #f3f3f3;

                    @media (max-width: 700px) {
                        margin-left: 10px;
                        font-size: 14px;
                    }
                }
            }

            .operating-box {
                padding-left: 20px;

                .flex-shrink;
                .flex;
                .flex-center-items;

                .btn-box {
                    width: 35px;
                    height: 35px;
                    margin-left: 15px;
                    cursor: pointer;

                    .flex;
                    .flex-center-all;

                    &:first-child {
                        margin-left: initial;
                    }

                    @media (max-width: 700px) {
                        display: none;
                    }
                }

                .search-box {
                    position: relative;
                    width: 250px;
                    height: 35px;
                    margin-right: 20px;

                    @media (max-width: 700px) {
                        // width: 35px;
                        // height: 35px;
                        // margin-right: 0;
                        display: none;
                    }

                    .search-base {
                        overflow: hidden;
                        background: #143f51;

                        .radius(8px);
                        .absolute(0, 0, initial, 0);

                        .search {
                            width: 100%;
                            height: 35px;

                            .flex();
                            .flex-center-items();

                            .icon-box {
                                width: 20px;
                                height: 20px;
                                margin: 0 10px;
                            }

                            .search-input {
                                font-size: 14px;
                                padding-right: 20px;

                                .flex-grow();

                                @media (max-width: 700px) {
                                    display: none;
                                }

                                input {
                                    width: 100%;
                                    font-size: 14px;
                                    color: #fff;

                                    &::-webkit-input-placeholder {
                                        color: #e3e3e3;
                                    }
                                }
                            }
                        }

                        .search-result {
                            width: 100%;
                            max-height: 300px;
                            border-top: 1px solid #e3e3e3;

                            .scroll-y;

                            .result-item {
                                padding: 0 20px;
                                height: 40px;
                                border-bottom: 1px solid #e3e3e3;
                                background: #fff;

                                .flex;
                                .flex-center-items;
                                .flex-content(space-between);

                                &:last-child {
                                    border-bottom: initial;
                                }

                                &:hover {
                                    color: #000;
                                    background: #d4d4d4;
                                }

                                p {
                                    color: #000;
                                    overflow: hidden;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                    font-size: 13px;
                                }

                                .name {
                                    margin-right: 10px;

                                    .flex-shrink;
                                }
                            }
                        }
                    }

                    .search-activity {
                        border-color: #b3b3b3;
                        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                        z-index: 20;
                    }
                }

                .user-box {
                    cursor: pointer;
                    margin-left: 20px;

                    .flex;
                    .flex-items(flex-end);

                    .avatar-box {
                        position: relative;
                        width: 30px;
                        height: 30px;
                        overflow: hidden;

                        .radius(50%);
                        .shadow;

                        .status {
                            width: 6px;
                            height: 6px;
                            background: green;
                            border: 1px solid #fff;

                            .radius(50%);
                            .absolute(initial, 0, 0, initial);
                        }
                    }

                    .btn-icon {
                        width: 10px;
                        height: 10px;
                        margin-left: 5px;
                    }
                }
            }
        }

        > .content-box {
            position: relative;
            margin: 10px 40px 20px 40px;
            background: #fff;
            overflow: hidden;

            .shadow(5px 5px 10px rgba(0,0,0,0.2));
            .radius(30px);
            .flex-grow;

            &.content-dark {
                background: @dark_background;
            }

            .content-scroll {
                width: 100%;
                height: 100%;

                .scroll-y(5px);
            }

            @media (max-width: 700px) {
                margin: 10px 20px 20px 20px;
            }

            @media (max-width: 400px) {
                margin: 10px 10px 10px 10px;
            }
        }
    }

    .online-activity {
        right: 400px;

        @media (max-width: 1300px) {
            right: 0;
        }
    }

    // 在线服务
    .online-service {
        width: 400px;
        z-index: 50;

        // .shadow();
        .fixed(0, -400px, 0, initial);
        .transition();

        // 把手
        .knob {
            cursor: pointer;
            width: 20px;
            height: 80px;
            background: #00a2ff;
            margin-top: -40px;

            .shadow();
            .radius(10px 0 0 10px);
            .absolute(50%, initial, initial, -20px);
            .flex();
            .flex-center-all();
            .transition();

            img {
                width: 15px;
                height: 15px;
            }
        }

        .box {
            position: relative;
            height: ~"calc(100% - 60px)";
            padding: 30px 40px;
            background: #f6f5fa;
            z-index: 1;

            .flex();
            .flex-column();

            .service-menu {
                width: 100%;

                .flex-shrink();
                .flex();
                .flex-center-items();

                .menu-item {
                    cursor: pointer;
                    position: relative;
                    margin-right: 20px;
                    height: 40px;

                    .flex();
                    .flex-center-all();

                    &::after {
                        content: "";
                        background: #00a2ff;
                        height: 2px;
                        width: 0;

                        .transition(0.2s);
                        .radius(2px);
                        .absolute(initial, initial, 0, 0);
                    }

                    &:hover {
                        &::after {
                            width: 30px;
                        }

                        p {
                            color: #000;
                        }
                    }

                    p {
                        color: #b6b2c4;
                        font-size: 18px;
                        letter-spacing: 2px;
                        text-indent: 2px;
                        font-weight: bold;

                        .transition(0.2s);
                    }
                }

                .menu-item-activity {
                    &::after {
                        width: 30px;
                    }

                    p {
                        color: #000;
                    }
                }

                .online-quantity {
                    width: 40px;
                    height: 35px;
                    background: #fff;

                    .radius(5px);
                    .flex();
                    .flex-center-all();

                    p {
                        font-size: 12px;
                        letter-spacing: 1px;
                        color: #00a2ff;
                        font-weight: bold;
                    }
                }
            }

            .new-message {
                width: 100%;

                .flex-grow();
                .flex();
                .flex-column();

                .user-fast {
                    margin: 20px 0;
                    width: 100%;
                    flex-wrap: wrap;

                    .flex-shrink();
                    .flex();

                    .user-item {
                        cursor: pointer;
                        position: relative;
                        margin: 9px 17.5px 9px 0;
                        width: 50px;
                        height: 50px;
                        overflow: hidden;

                        .radius(15px);
                        .flex();
                        .flex-center-all();

                        &::after {
                            content: "";

                            .radius(15px);
                            .absolute(-2px,-2px,-2px,-2px);
                        }

                        &:nth-child(5n + 0) {
                            margin-right: 0;
                        }
                    }

                    .user-item-activity::after {
                        border: 2px solid #00a2ff;
                    }
                }

                .chat-window {
                    width: 100%;
                    border-top: 1px solid #e3e3e3;

                    .flex-grow();
                    .flex();
                    .flex-column();

                    .title {
                        padding: 20px 0;
                        height: 50px;

                        .flex();
                        .flex-center-items();
                        .flex-shrink(0);

                        p {
                            font-size: 25px;
                            letter-spacing: 3px;
                            font-weight: bold;
                        }
                    }

                    .dialogue-box {
                        .flex-grow(1);
                        .scroll-y;

                        .item {
                            padding: 10px 0;

                            .flex-items(flex-start);
                            .flex-column();
                            .flex();

                            .info {
                                height: 40px;

                                .flex();

                                .avatar {
                                    width: 40px;
                                    height: 40px;
                                    background: #fff;
                                    overflow: hidden;

                                    .radius(10px);
                                    .shadow(0 0 10px rgba(0, 0, 0, 0.1));
                                }

                                .name-date {
                                    padding-left: 10px;

                                    .flex();
                                    .flex-column();
                                    .flex-center-content();

                                    .name {
                                        font-size: 16px;
                                        letter-spacing: 2px;
                                        font-weight: bold;
                                        padding-bottom: 2px;
                                        color: #232d40;
                                    }

                                    .date {
                                        font-weight: bold;
                                        letter-spacing: 1px;
                                        font-size: 8px;
                                        color: #a3a8b3;
                                    }
                                }
                            }

                            .chat-con {
                                float: left;
                                padding: 15px 20px;
                                margin: 10px 0 0 50px;
                                background: #ecf3fa;
                                color: #727e99;
                                letter-spacing: 2px;

                                .radius(10px);

                                p {
                                    word-break: break-word;
                                }
                            }
                        }

                        .current {
                            .flex-items(flex-end);

                            .info {
                                flex-direction: row-reverse;
                            }

                            .name-date {
                                padding-left: 0;
                                padding-right: 10px;
                                text-align: right;
                            }

                            .chat-con {
                                float: right;
                                margin: 10px 50px 0 0;
                                background: #00a2ff;
                                color: #fff;
                            }
                        }
                    }

                    .input-box {
                        height: 40px;
                        padding: 5px;
                        margin-top: 30px;
                        background: #edf3fb;

                        .radius(10px);
                        .flex-shrink(0);

                        .input-form {
                            height: 100%;

                            .flex();

                            .input {
                                height: 100%;
                                padding: 0 20px 0 10px;

                                .flex();
                                .flex-center-items();
                                .flex-grow(1);

                                input {
                                    width: 100%;
                                    font-size: 18px;
                                }
                            }

                            .submit {
                                cursor: pointer;
                                width: 40px;
                                height: 40px;
                                background: #00a2ff;
                                border: 0;

                                .radius(10px);
                                .flex-shrink(0);

                                img {
                                    width: 25px;
                                    height: 25px;
                                    padding: 7.5px;
                                }
                            }
                        }
                    }
                }
            }

            .user-lists {
                margin-top: 20px;
                width: 100%;

                .flex-grow();
                .scroll-y;

                .user-item {
                    cursor: pointer;
                    width: 100%;
                    height: 90px;

                    .flex();
                    .flex-center-items();

                    .avatar {
                        width: 60px;
                        height: 60px;
                        overflow: hidden;

                        .radius(10px);
                        .flex-shrink();
                    }

                    .info {
                        margin-left: 20px;
                        height: 100%;
                        border-bottom: 1px solid #e3e3e3;

                        .flex-grow();
                        .flex();
                        .flex-column();
                        .flex-center-content();

                        .username-time {
                            width: 100%;

                            .flex();
                            .flex-center-items();
                            .flex-content(space-between);

                            .username {
                                padding-right: 10px;
                                font-size: 18px;
                                letter-spacing: 1px;
                                font-weight: bold;
                                overflow: hidden;
                                text-overflow: ellipsis;

                                .flex-grow();
                            }

                            .time {
                                font-size: 12px;
                                letter-spacing: 1px;
                                color: #666;

                                .flex-shrink();
                            }

                            p {
                                white-space: nowrap;
                            }
                        }

                        .chat-content {
                            padding-top: 5px;
                            width: 100%;

                            .flex();
                            .flex-center-items();

                            p {
                                max-width: 100%;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                color: #666;
                                letter-spacing: 1px;
                                font-size: 16px;
                            }
                        }
                    }
                }
            }
        }
    }

    .online-open-feedback:hover {
        transform: translateX(-10px);
    }

    .online-service-display {
        transform: translateX(-400px);
        border-left: 1px solid #e3e3e3;

        @media (max-width: 1300px) {
            border-left: initial;

            .shadow;
        }
    }
}

.index-page-dark {
    .sidebar {
        background: rgba(30, 35, 41, 0.7);
        border: 1px solid rgba(255, 255, 255, 0.05);

        .main-menu-pc {
            .menu-item {
                &:hover {
                    background: rgba(255, 255, 255, 0.05);
                }

                .menu-child-base {
                    &::after {
                        border-right: 12px solid rgba(43, 44, 58, 0.95);
                    }

                    .menu-child-box {
                        background: rgba(43, 44, 58, 0.95);
                        border: 1px solid rgba(255, 255, 255, 0.05);

                        .menu-child-item {
                            &:hover > .menu-child-item-box {
                                background: rgba(255, 255, 255, 0.08);

                                .menu-child-name {
                                    color: #fff;
                                }
                            }

                            .menu-child-item-box {
                                &::after {
                                    border-color: rgba(255, 255, 255, 0.05);
                                }

                                .menu-child-name {
                                    color: rgb(230, 230, 230);
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
